import React from "react";
import { cn } from "@charphq/ui/lib/utils";

interface EntityCardProps {
  children: React.ReactNode;
  onClick?: () => void;
  className?: string;
  isLoading?: boolean;
  loadingText?: string;
}

export function EntityCard({
  children,
  onClick,
  className,
  isLoading = false,
  loadingText = "Loading...",
}: EntityCardProps) {
  return (
    <div
      className={cn(
        "relative h-[120px] rounded-lg border bg-card p-4 transition-all duration-200",
        "hover:shadow-md hover:border-primary/50",
        onClick && "cursor-pointer",
        className,
      )}
      onClick={onClick}
    >
      {children}

      {isLoading && (
        <div className="absolute inset-0 flex items-center justify-center rounded-lg bg-background/80 backdrop-blur-sm">
          <div className="flex items-center gap-2 text-sm text-muted-foreground">
            <div className="h-4 w-4 animate-spin rounded-full border-2 border-primary border-t-transparent" />
            {loadingText}
          </div>
        </div>
      )}
    </div>
  );
}
